import HTTP from "@/_helpers/http";
import { IBREQUEST__API } from "@/_helpers/urls";
import { IBREQUEST__MUTATIONS } from "../mutation-types";
import { IBREQUEST__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
    allpendings: [],
    allrejected: [],
    latestibrequests: [],
    totalRequest: 0,
    totalPendingRequest: 0,
    totalRejectedRequest: 0,
    isLoading: false,
    rejectIbIsLoading: false,
    ibDetails: [],
    ibDetailfilter: [],
    topperformedlists: [],
    pagination: {
        total: 0,
        perPage: 10,
        currentPage: 1,
        lastPage: 1
    },
    rejectIbPagination: {
        total: 0,
        perPage: 10,
        currentPage: 1,
        lastPage: 1
    }
};

// Getters
const getters = {};

// Mutations
const mutations = {
    [IBREQUEST__MUTATIONS.ALLPENDINGIBREQUEST](state, data) {
        state.allpendings = data?.data?.summaries;
        state.totalRequest = data?.data?.totalRequest;
        state.totalPendingRequest = data?.data?.totalPendingRequest;
        state.pagination = data?.data?.pagination;
    },
    [IBREQUEST__MUTATIONS.ALLREJECTEDIBREQUEST](state, data) {
        state.allrejected = data?.allRejectedIBrequest;
        state.totalRejectedRequest = data?.totalRejectedRequest;
        state.rejectIbPagination = data?.pagination;
    },
    [IBREQUEST__MUTATIONS.LATESTIBREQUEST](state, data) {
        state.latestibrequests = data.latestRequests;
    },
    SET_LOADING(state, data) {
        state.isLoading = data;
    },
    SET_REJIB_LOADING(state, data) {
        state.rejectIbIsLoading = data;
    },
    [IBREQUEST__MUTATIONS.TOPIBDETAILS](state, data) {
        state.ibDetails = data?.data || [];
        state.pagination = data?.data?.pagination;
    },
     [IBREQUEST__MUTATIONS.TOPIBDETAILSFILTER](state, data) {
        state.ibDetailfilter = data?.data || [];
    },
    [IBREQUEST__MUTATIONS.ALLTOPPERFORMEDIB](state, data) {
    state.topperformedlists = Array.isArray(data?.data) ? data.data : data;
    }
};

// Actions
const actions = {
    async [IBREQUEST__ACTIONS.UPDATEIBREQ]({ commit, dispatch }, parameter) {
        try {
            const idParam = parameter?.client_id != null ? `client_id=${parameter.client_id}` : "";
            const statusParam = parameter?.new_status != null ? `new_status=${parameter.new_status}` : "";

            const parameterString = [idParam, statusParam]
                .filter((param) => param !== "")
                .join("&");

            const response = await HTTP().put(
                IBREQUEST__API.UPDATEIBREQ + (parameterString !== "" ? `?${parameterString}` : "")
            );

            if (response.status === 200) {
                const refreshParams = {
                    page: 1,
                    limit: 10,
                    search: "",
                    duration: ""
                };

                // Dispatch both actions with parameters
                await Promise.all([
                    dispatch(IBREQUEST__ACTIONS.ALLPENDINGIBREQUEST, refreshParams),
                    dispatch(IBREQUEST__ACTIONS.ALLREJECTEDIBREQUEST, refreshParams)
                ]);

                toast.success(response.data.message || 'Status updated successfully');
            }

        } catch (error) {
            console.log(error);
            // Proper error message handling
            const errorMessage = error.response?.data?.message || error.message || 'Failed to update status';
            toast.error(errorMessage);
        }
    },

    async [IBREQUEST__ACTIONS.ALLPENDINGIBREQUEST]({ commit }, parameter = {}) {
        try {
            commit("SET_LOADING", true);
            const {
                page = 1,
                limit = 10,
                search = "",
                duration
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(duration && { duration }),
                ...(search && { search })
            }).toString();

            const response = await HTTP().get(
                `${IBREQUEST__API.ALLPENDINGIBREQUEST}${queryParams ? `?${queryParams}` : ''}`
            );

            commit(IBREQUEST__MUTATIONS.ALLPENDINGIBREQUEST, response.data);
            commit("SET_LOADING", false);
        } catch (error) {
            console.log(error);
        }
    },

    async [IBREQUEST__ACTIONS.ALLREJECTEDIBREQUEST]({ commit }, parameter = {}) {
        try {
            commit("SET_REJIB_LOADING", true);
            const {
                duration,
                page = 1,
                limit = 10,
                search = ""
            } = parameter;

            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(duration && { duration }),
                ...(search && { search })
            }).toString();

            const response = await HTTP().get(
                `${IBREQUEST__API.ALLREJECTEDIBREQUEST}${queryParams ? `?${queryParams}` : ''}`
            );

            commit(IBREQUEST__MUTATIONS.ALLREJECTEDIBREQUEST, response.data);
            commit("SET_REJIB_LOADING", false);
        } catch (error) {
            console.log(error);
        }
    },

    async [IBREQUEST__ACTIONS.LATESTIBREQUEST]({ commit }) {
        try {
            const response = await HTTP().get(IBREQUEST__API.LATESTIBREQUEST
            );

            commit(IBREQUEST__MUTATIONS.LATESTIBREQUEST, response.data);
        } catch (error) {
            console.log(error);
        }
    },
    async [IBREQUEST__ACTIONS.TOPIBDETAILS]({ commit }, params ) {
        try {
            const {
                page = 1,
                limit = 10,
                search = "",
                filter_by = ""
            } = params;
            const queryParams = new URLSearchParams({
                page: page.toString(),
                limit: limit.toString(),
                ...(search && { search }),
                ...(filter_by && { filter_by })
            }).toString();

            const response = await HTTP().get(
                `${IBREQUEST__API.TOPIBDETAILS}${queryParams ? `?${queryParams}` : ""}`
            );

            commit(IBREQUEST__MUTATIONS.TOPIBDETAILS, response.data);
            console.log(response.data);
        } catch (error) {
            console.log(error);
        }
    },

    async [IBREQUEST__ACTIONS.TOPIBDETAILSFILTER]({ commit }) {
        try {
            const response = await HTTP().get(IBREQUEST__API.TOPIBDETAILSFILTER
            );
            commit(IBREQUEST__MUTATIONS.TOPIBDETAILSFILTER, response.data);
        } catch (error) {
            console.log(error);
        }
    },
    async [IBREQUEST__ACTIONS.ALLTOPPERFORMEDIB]({ commit, state }) {
        try {
          const response = await HTTP().get(IBREQUEST__API.ALLTOPPERFORMEDIB);
        //   console.log(response);
    
          if (response.status === 200) {
            commit(IBREQUEST__MUTATIONS.ALLTOPPERFORMEDIB, response.data);
          }
        } catch (error) {
          console.log(error);
        }
      },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
